/**
 * Product Card Grid — size/variant dropdown interaction.
 * Updates the hidden form variant input and enables/disables the ATC button.
 */
document.addEventListener('change', (event) => {
  const select = event.target.closest('.pcg-card__size-select');
  if (!select) return;

  const formId = select.dataset.formId;
  const form = document.getElementById(formId);
  if (!form) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantId = select.value;
  const available = selectedOption.dataset.available === 'true';

  const variantInput = form.querySelector('.product-variant-id');
  if (variantInput) {
    variantInput.value = variantId;
    variantInput.disabled = !available;
  }

  // Swap card image to the selected variant's image (if it has one)
  const variantImage = selectedOption.dataset.variantImage;
  if (variantImage) {
    const card = select.closest('.pcg-card');
    const img = card?.querySelector('.pcg-card__img');
    if (img && img.tagName === 'IMG') {
      img.src = variantImage;
    }
  }

  const submitBtn = form.querySelector('[type="submit"]');
  if (!submitBtn) return;

  const labelSpan = submitBtn.querySelector('.pcg-card__btn-label');
  const soldOutSpan = submitBtn.querySelector('.sold-out-message');

  if (available) {
    submitBtn.removeAttribute('disabled');
    if (labelSpan) labelSpan.textContent = window.pcgStrings?.addToCart || 'Add to Cart';
    if (soldOutSpan) soldOutSpan.classList.add('hidden');
  } else {
    submitBtn.setAttribute('disabled', 'disabled');
    if (labelSpan) labelSpan.textContent = window.pcgStrings?.soldOut || 'Sold Out';
    if (soldOutSpan) soldOutSpan.classList.remove('hidden');
  }
});

// Holds reference to the Shopify product form that triggered the popup
let _pendingAtcForm = null;

// Intercept .pcg-card form submit → size popup + (collection only) custom fields popup
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target.closest('.pcg-card__actions form');
    if (!form) return;

    const isRelated = !!form.closest('product-recommendations');

    const card = form.closest('.pcg-card');
    const sizeSelect = card?.querySelector('.pcg-card__size-select');

    if (sizeSelect) {
      if (!sizeSelect.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showSizeRequiredPopup();
        return;
      }
      const selectedOpt = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOpt?.dataset.available === 'false') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    // Related products: valid size chosen → let form submit normally
    if (isRelated) return;

    // Collection page: show custom fields popup
    event.preventDefault();
    event.stopImmediatePropagation();
    _pendingAtcForm = form;
    showCustomFieldsPopup();
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  const addEl = document.querySelector('[data-add-to-cart-text]');
  const soldEl = document.querySelector('[data-sold-out-text]');
  window.pcgStrings = {
    addToCart: (addEl && addEl.dataset.addToCartText) || 'Add to Cart',
    soldOut: (soldEl && soldEl.dataset.soldOutText) || 'Sold Out',
  };

  initCollectionTagTabs();
});

// ── Size Required Popup ───────────────────────────────────────────

function showSizeRequiredPopup() {
  let popup = document.querySelector('.pcg-size-popup');

  if (!popup) {
    popup = document.createElement('div');
    popup.className = 'pcg-size-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.innerHTML = `
      <div class="pcg-size-popup__box" tabindex="-1">
        <p class="pcg-size-popup__title">UNABLE TO PURCHASE ITEM</p>
        <p class="pcg-size-popup__message">Please select the Size option.</p>
        <button type="button" class="pcg-size-popup__button">OKAY</button>
      </div>
    `;
    document.body.appendChild(popup);

    popup.addEventListener('click', (event) => {
      if (event.target === popup || event.target.closest('.pcg-size-popup__button')) {
        hideSizeRequiredPopup();
      }
    });
  }

  popup.classList.add('is-visible');
  popup.removeAttribute('hidden');
  popup.querySelector('.pcg-size-popup__box')?.focus();
}

function hideSizeRequiredPopup() {
  const popup = document.querySelector('.pcg-size-popup');
  if (!popup) return;
  popup.classList.remove('is-visible');
  popup.setAttribute('hidden', '');
}

// ── Custom Fields Popup ───────────────────────────────────────────
// Fields use properties[...] names → Shopify shows them in cart & order

function showCustomFieldsPopup() {
  let popup = document.querySelector('.pcg-contact-popup');

  if (!popup) {
    popup = document.createElement('div');
    popup.className = 'pcg-contact-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Order details');
    popup.innerHTML = `
      <div class="pcg-contact-popup__backdrop"></div>
      <div class="pcg-contact-popup__box" tabindex="-1">
        <button type="button" class="pcg-contact-popup__close" aria-label="Close">&#x2715;</button>
        <p class="pcg-contact-popup__intro">
          The recipient's name and address can be added at the checkout stage after clicking "Pay," before
          finalizing the payment. Shipping costs are automatically calculated based on the delivery postal
          code once the address is entered. Please include any additional information in the section below.
        </p>
        <form class="pcg-contact-popup__form" novalidate>
          <input type="hidden" name="id" class="pcg-popup-variant-id" value="">
          <input type="hidden" name="quantity" value="1">
          <div class="pcg-contact-popup__field">
            <p class="pcg-contact-popup__label">Personal Message to the receiver</p>
            <p class="pcg-contact-popup__hint">Our bouquets include a standard elegant gift card</p>
            <textarea class="pcg-contact-popup__textarea" name="properties[Personal Message]" rows="4"></textarea>
          </div>
          <div class="pcg-contact-popup__field">
            <p class="pcg-contact-popup__label">Telephone number of the receiver</p>
            <p class="pcg-contact-popup__hint">So we can contact the receiver to verify delivery date and time.</p>
            <input class="pcg-contact-popup__input" type="tel" name="properties[Receiver Phone]" autocomplete="tel">
          </div>
          <div class="pcg-contact-popup__field">
            <p class="pcg-contact-popup__label">Preferred Delivery Date &amp; Time</p>
            <p class="pcg-contact-popup__hint">What day do you want your order to be delivered?</p>
            <input class="pcg-contact-popup__input" type="text" name="properties[Delivery Date]" placeholder="01/05/2025 at 5pm">
          </div>
          <div class="pcg-contact-popup__field">
            <p class="pcg-contact-popup__label">Any specific remarks?</p>
            <p class="pcg-contact-popup__hint">Specific instructions or preferences (colours, ...) can be mentioned here.</p>
            <textarea class="pcg-contact-popup__textarea" name="properties[Remarks]" rows="4" placeholder="No red flowers please"></textarea>
          </div>
          <button type="submit" class="pcg-contact-popup__submit">Purchase</button>
        </form>
      </div>
    `;
    document.body.appendChild(popup);

    popup.querySelector('.pcg-contact-popup__backdrop').addEventListener('click', hideContactPopup);
    popup.querySelector('.pcg-contact-popup__close').addEventListener('click', hideContactPopup);
    popup.querySelector('.pcg-contact-popup__form').addEventListener('submit', handleCustomFieldsSubmit);
  }

  // Reset form and sync the current variant ID from the pending Shopify form
  const form = popup.querySelector('.pcg-contact-popup__form');
  form?.reset();
  const variantIdInput = form?.querySelector('.pcg-popup-variant-id');
  if (variantIdInput && _pendingAtcForm) {
    const formVariant = _pendingAtcForm.querySelector('.product-variant-id');
    variantIdInput.value = formVariant?.value || '';
  }

  popup.classList.add('is-visible');
  document.body.classList.add('overflow-hidden');
  popup.querySelector('.pcg-contact-popup__box')?.focus();
}

function hideContactPopup() {
  const popup = document.querySelector('.pcg-contact-popup');
  if (!popup) return;
  popup.classList.remove('is-visible');
  document.body.classList.remove('overflow-hidden');
  _pendingAtcForm = null;
}

function handleCustomFieldsSubmit(event) {
  event.preventDefault();
  const form = event.target;
  const submitBtn = form.querySelector('.pcg-contact-popup__submit');

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding…';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams(new FormData(form)).toString(),
  })
    .then((res) => res.json())
    .then((data) => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Purchase';
      }

      if (data.status) {
        alert(data.description || 'Could not add to cart. Please try again.');
        return;
      }

      hideContactPopup();
      openRefreshedCartDrawer();
    })
    .catch(() => {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Purchase';
      }
      alert('Something went wrong. Please try again.');
    });
}

function openRefreshedCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // Fetch fresh section HTML via GET — avoids any encoding issues from POST body
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then((r) => r.json())
    .then((sections) => {
      const parser = new DOMParser();

      // Replace #CartDrawer inner HTML with the server-rendered version that
      // includes the newly added item and its properties
      if (sections['cart-drawer']) {
        const freshDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        const freshInner = freshDoc.querySelector('#CartDrawer');
        const liveInner = document.querySelector('#CartDrawer');
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
      }

      // Update the cart count bubble in the header
      if (sections['cart-icon-bubble']) {
        const freshDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        const freshBubble = freshDoc.getElementById('cart-icon-bubble');
        const liveBubble = document.getElementById('cart-icon-bubble');
        if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
      }

      // Remove is-empty from the cart-drawer element so CSS shows items,
      // not the "your cart is empty" placeholder
      drawer.classList.remove('is-empty');

      // Re-attach overlay close listener (lost when innerHTML was replaced)
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));

      if (typeof drawer.open === 'function') drawer.open();
    })
    .catch(() => {
      // Fallback: open whatever is already rendered
      if (typeof drawer.open === 'function') drawer.open();
    });
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    hideSizeRequiredPopup();
    hideContactPopup();
  }
});

// ── Collection Tag Tabs ───────────────────────────────────────────

function initCollectionTagTabs() {
  const nav = document.querySelector('.collection-tag-tabs');
  if (!nav) return;

  const tabs = nav.querySelectorAll('.collection-tag-tab');
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  // Ensure ALL tab is active on first load when no tag is filtered
  const activeTab = nav.querySelector('.collection-tag-tab--active');
  if (!activeTab) {
    const allTab = nav.querySelector('[data-tab-tag=""]');
    if (allTab) {
      allTab.classList.add('collection-tag-tab--active');
      allTab.setAttribute('aria-current', 'page');
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Update active class
      tabs.forEach((t) => {
        t.classList.remove('collection-tag-tab--active');
        t.setAttribute('aria-current', 'false');
      });
      tab.classList.add('collection-tag-tab--active');
      tab.setAttribute('aria-current', 'page');

      const selectedTag = tab.dataset.tabTag; // '' = ALL, 'flowers' = tag handle

      // Filter grid items
      const items = grid.querySelectorAll('.grid__item');
      items.forEach((item) => {
        if (!selectedTag) {
          item.style.display = '';
        } else {
          const tags = (item.dataset.productTags || '').split('|').filter(Boolean);
          item.style.display = tags.includes(selectedTag) ? '' : 'none';
        }
      });
    });
  });
}
